export default __webpack_public_path__ + "static/4-e8c8c9cf1b78beddb1a03668805801f6.jpg";